import { IIdTitle, IdTitle } from "ui/Scripts/source/models/common/idTitle";
import { Base } from "ui/Scripts/source/framework/base";
import { IFolderNode, FolderNode } from "ui/Scripts/source/models/document/folderNode";
import { DocumentFolderEditItem, IDocumentFolderEditItem } from "./documentFolderItem";
import { IUnitPermissionUserGroup, UnitPermissionUserGroup } from "../userGroup/unitPermissionUserGroup";

export interface IDocumentFolderEdit {
    path: string;
    canUseAllCompanyGroup: boolean;
    maxFolderNameLength: number;
    folderNode: IFolderNode;
    userGroups: IUnitPermissionUserGroup[];
    companyGroups: IUnitPermissionUserGroup[];
    fileFilters: IIdTitle[];
    item: IDocumentFolderEditItem;
}

export class DocumentFolderEdit implements IDocumentFolderEdit {
    path: string;
    canUseAllCompanyGroup: boolean;
    maxFolderNameLength: number;
    folderNode: FolderNode;
    userGroups: UnitPermissionUserGroup[];
    companyGroups: UnitPermissionUserGroup[];
    fileFilters: IdTitle[];
    item: DocumentFolderEditItem;

    constructor();
    constructor(obj: IDocumentFolderEdit);
    constructor(obj?: any) {
        this.path = obj && obj.path || "";
        this.canUseAllCompanyGroup = obj && obj.canUseAllCompanyGroup || false;
        this.maxFolderNameLength = obj && obj.maxFolderNameLength || 0;
        this.folderNode = null;
        if (obj?.folderNode) {
            this.folderNode = new FolderNode(obj.folderNode);
        }
        this.userGroups = Base.getTypedArray(obj ? obj.userGroups : null, UnitPermissionUserGroup);
        this.companyGroups = Base.getTypedArray(obj ? obj.companyGroups : null, UnitPermissionUserGroup);
        this.fileFilters = Base.getTypedArray(obj ? obj.fileFilters : null, IdTitle);
        this.item = new DocumentFolderEditItem(obj ? obj.item : null);
    }
}